import type { ReactNode } from 'react';

export const symbol_detector_status: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m438-205 148-148q9.07-9.23 21.53-9.62Q620-363 629-353.95q9 9.06 9 21.5 0 12.45-9 21.45L459-141q-9 9-21 9t-21-9l-86-86q-9-9-8.5-21t9.5-21.39q9-8.61 21-8.61t21 9l64 64ZM180-780v60h600v-60H180Zm121 120 18 60h322l18-60H301Zm18 120q-19.5 0-35.25-11.63Q268-563.25 262-582l-25-78h-57q-24.75 0-42.37-17.63Q120-695.25 120-720v-60q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v60q0 24.75-17.62 42.37Q804.75-660 780-660h-57l-30 81q-6.93 17.25-22.34 28.12Q655.26-540 636-540H319ZM180-780v60-60Z"
		/>
	</svg>
);
